class SignUp
{
    constructor(phonePrefixes, partnerTypeID, userLocation) {
        this.initForm(phonePrefixes, partnerTypeID, userLocation);
        this.validateSignUpForm();
        this.partnerQuestions = [];
    }

    initForm(phonePrefixes, partnerTypeID, userLocation) {
        this.setSelectData('selected_country', 'Country', userLocation);
        this.setSelectData('selected_type', 'partner_type', partnerTypeID, true);
        this.setSelectData('selected_need', 'need', $('#PartnerNeedSelect option:eq(0)').val(), true);
        this.setSelectData('selected_company_size', 'CompanySize', $('select[name="CompanySize"] option:eq(0)').val(), true);
        this.initPartnerQuestions();
    }
    validateSignUpForm() {
        let form = document.getElementById('frm-signUpForm-signUpForm');
        let thisClass = this;
        if(form) {
            let submitButton = document.getElementById('partner_sign_up_button');

            let validator = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'first_name': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    max: 64,
                                    message: 'First Name cannot be over 64 characters',
                                },
                                regexp: {
                                    regexp: /^\S.*/,
                                    message: 'Please input your First Name in correct format',
                                }
                            },
                        },
                        'last_name': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    max: 64,
                                    message: 'Last Name cannot be over 64 characters',
                                },
                                regexp: {
                                    regexp: /^\S.*/,
                                    message: 'Please input your Last Name in correct format',
                                }
                            },
                        },
                        'company_email': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                regexp: {
                                    regexp: /^(?:[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/,
                                    message: 'Please enter a valid email',
                                },
                                stringLength: {
                                    max: 45,
                                    message: 'Email must be less than 45 characters',
                                },
                            },
                        },
                        'PhoneNumber': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    min: 7,
                                    max: 15,
                                    message: 'Phone Number has to be between 7 and 15 characters long',
                                },
                                regexp: {
                                    regexp: /^[+(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\/0-9]*$/,
                                    message: 'You used a forbidden character',
                                }
                            }
                        },
                        'Country': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                            }
                        },
                        'company_position': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    min: 3,
                                    max: 40,
                                    message: 'Company role must be between 3 and 40 characters'
                                },
                                regexp: {
                                    regexp: /^\S.*/,
                                    message: 'Please input your Company Position in correct format',
                                }
                            }
                        },
                        'company_name': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    min: 3,
                                    max: 40,
                                    message: 'Company role must be between 3 and 40 characters'
                                },
                                regexp: {
                                    regexp: /^\S.*/,
                                    message: 'Please input your Company Name in correct format',
                                }
                            }
                        },
                        'partner_type': {
                            validator: {
                                notEmpty: {
                                    message: 'This field is required'
                                }
                            }
                        },
                        'CompanySize': {
                            validator: {
                                notEmpty: {
                                    message: 'This filed is required'
                                }
                            }
                        },
                        'need': {
                            validator: {
                                notEmpty: {
                                    message: 'This field is required'
                                }
                            }
                        }
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        })
                    }
                }
            ).on('core.element.validated', function(e) {
                if(e.element.attributes.name.value === 'Password' || e.element.attributes.name.value === 'Country'){
                    // Get the icon plugin instance
                    const iconPlugin = validator.getPlugin('icon');
                    const iconElement = iconPlugin && iconPlugin.icons.has(e.element) ? iconPlugin.icons.get(e.element) : null;
                    // Hide the icon
                    iconElement && (iconElement.style.display = 'none');
                }
            }).on('core.validator.validated', function (e) {
                if (!e.result.valid) {
                    // Query all messages
                    const messages = [].slice.call(form.querySelectorAll('[data-field="' + e.field + '"][data-validator]'));
                    messages.forEach((messageEle) => {
                        const validator = messageEle.getAttribute('data-validator');
                        messageEle.style.display = validator === e.validator ? 'block' : 'none';
                    });
                }
            }).on('core.form.validating', function(event) {
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                submitButton.disabled = true;
            }).on('core.form.valid', function(e) {
                // Submit form
                $('input[name="questions"]').val(thisClass.partnerQuestions);
                form.submit();
            }).on('core.form.invalid', function(event) {
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
            });
        }
    }

    initPartnerQuestions() {
        let thisClass = this;

        this.selectPartnerQuestions();

        $('.partner-question').on('click', function() {
            let val = $(this).val();
            if(this.checked) {
                if(thisClass.partnerQuestions.indexOf(val) !== -1)
                    return;

                thisClass.partnerQuestions.push(this.value);

            }else {
                if(thisClass.partnerQuestions.indexOf(val) === -1)
                    return;

                thisClass.partnerQuestions.splice(thisClass.partnerQuestions.indexOf(val), 1);
            }
        });
    }

    setSelectData(hidden, select, defaultValue, create = false) {
        let typeHidden = $('input[name="'+hidden+'"]');
        let selected = typeHidden.val() !== '' ? typeHidden.val() : defaultValue;

        if(create) {
            $('select[name="'+select+'"]').select2();
        }

        $('select[name="'+select+'"]')
            .val(selected).trigger('change')
            .on('select2:select', function(e) {
                $('input[name="'+hidden+'"]').val(e.params.data.id);
            });
    }
    selectPartnerQuestions() {
        let selectedQuestions = $('input[name=questions]').val();
        if(selectedQuestions) {
            selectedQuestions.split(',').forEach((question) => {
                $('input[value="'+question+'"].partner-question').prop('checked', true);
            });
        }
    }
}

window.SignUp = SignUp;